import { render, staticRenderFns } from "./SalesThermalpkReports2.vue?vue&type=template&id=55ffff17&"
import script from "./SalesThermalpkReports2.vue?vue&type=script&lang=js&"
export * from "./SalesThermalpkReports2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports